import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { DownloadsComponent } from './downloads.component';

export const downloadsRoutes: Routes = [
    {
        path: 'downloads',
        component: DownloadsComponent,
    },
];
export const downloadsRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(downloadsRoutes);